import { ControlProperty, ListRange, SearchCriteriaBase } from '../../../../../common/models';
import { DEFAULT_PAGE_SIZE, ListQueryParam } from '../../../../../common/constants';
import { Validators } from '@angular/forms';

export const ALL_HUBS_ID = 'ALL_HUBS';

export class TruckDriversSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Size] = DEFAULT_PAGE_SIZE;
  [ListQueryParam.Page] = 0;
  hubId: string;
  carrierExtId: string;
  firstName: string;
  lastName: string;
  idType: string;
  idNumber: string;
  phoneNumber: string;

  constructor(params?: TruckDriversSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export interface TruckDriverBrief {
  firstName: string;
  lastName: string;
  idTypes: string[];
  idNumbers: string[];
  phoneNumbers: string[];
  carrierExtIds: string[];
  carrierNames: string[];
  carrierNumbers: string[];
  frequentDriverIds: number[];
  truckIds: number[];
  tourExecutionIds: number[];
  frequentDriverIdsToHub: Record<string, string>;
  truckIdsToHub: Record<string, string>;
  tourExecutionIdsToHub: Record<string, string>;
  canBeDeleted: boolean;
}

export class TruckDriverSearchModel {
  firstName: string = null;
  lastName: string = null;
  hubId: string = ALL_HUBS_ID;
  phoneNumber: string = null;
  idType: string = null;
  idNumber: string = null;
  carrierExtId: string = null;
}

export class TruckDriverSearchForm {
  constructor(
    model: TruckDriverSearchModel,
    public firstName: ControlProperty<string> = model.firstName,
    public lastName: ControlProperty<string> = model.lastName,
    public hubId: ControlProperty<string> = [model.hubId, Validators.required],
    public phoneNumber: ControlProperty<string> = model.phoneNumber,
    public idType: ControlProperty<string> = model.idType,
    public idNumber: ControlProperty<string> = model.idNumber,
    public carrierExtId: ControlProperty<string> = model.carrierExtId,
  ) {}
}
